const MedalIcon = () => (
  <svg
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M72 0H8C3.58172 0 0 3.58171 0 7.99999V72.0002C0 76.4184 3.58172 80.0002 8 80.0002H72C76.4183 80.0002 80 76.4184 80 72.0002V8C80 3.58172 76.4183 0 72 0Z"
      fill="#F4EFED"
    />
    <path
      d="M15.5 0C15.5 13.5321 26.4702 24.5001 39.9987 24.5001C53.5271 24.5001 64.5002 13.5321 64.5002 0H15.5Z"
      fill="#0A0777"
    />
    <path
      d="M40.0001 24.5C26.4708 24.5 15.5 35.4329 15.5 48.9182C15.5 62.4035 26.4708 73.3335 40.0001 73.3335C53.5294 73.3335 64.5002 62.4006 64.5002 48.9182C64.5002 35.4357 53.5294 24.5029 40.0001 24.5029V24.5ZM36.0219 57.7502L35.5429 57.2729L29.0637 50.8161L31.8802 48.0093L36.0248 52.1395L48.1228 40.0833L50.9394 42.8901L36.0248 57.7531L36.0219 57.7502Z"
      fill="#FB6E44"
    />
  </svg>
);

export default MedalIcon;
